import { selectComboboxDefaults } from "@config/select"
import { createTheme, MantineColorsTuple } from "@mantine/core"

const brand: MantineColorsTuple = [
    "#f0f4fa",
    "#dfe4ed",
    "#bac7dd",
    "#93a9ce",
    "#728fc1",
    "#5e7eb9",
    "#5276b7",
    "#4365a1",
    "#3a5991",
    "#15243c"
]

const brandLight: MantineColorsTuple = [
    "#f0f4fa",
    "#dfe5ee",
    "#bac8de",
    "#93aacf",
    "#7291c2",
    "#5d81bb",
    "#5279b8",
    "#4367a2",
    "#395c92",
    "#14243b"
]

const brandHero: MantineColorsTuple = [
    "#edf3fc",
    "#d9e2f3",
    "#aec3ea",
    "#81a2e1",
    "#5c85da",
    "#4674d6",
    "#3a6bd5",
    "#2d5abd",
    "#2550aa",
    "#0f2c60"
]

const royal: MantineColorsTuple = [
    "#e6f7ff",
    "#d1eafe",
    "#a2d2f9",
    "#70b9f6",
    "#49a4f4",
    "#3396f3",
    "#2690f4",
    "#197cda",
    "#066cbf",
    "#005fad"
]

const aqua: MantineColorsTuple = [
    "#e5fff7",
    "#d3f9ed",
    "#aaf1db",
    "#7de8c7",
    "#59e1b6",
    "#41ddac",
    "#32dba6",
    "#20bc8c",
    "#0fad7f",
    "#00966c"
]

const berry: MantineColorsTuple = [
    "#fdedfa",
    "#f6d7f0",
    "#eeabe1",
    "#e77cd2",
    "#e056c6",
    "#dd3fbe",
    "#dc34bb",
    "#c328a5",
    "#ae2193",
    "#9e1685"
]

const coral: MantineColorsTuple = [
    "#ffeee2",
    "#ffdccc",
    "#ffb79a",
    "#ff9064",
    "#ff682c",
    "#ff5a18",
    "#ff4e07",
    "#e43f00",
    "#cc3600",
    "#b22a00"
]

const lemon: MantineColorsTuple = [
    "#fffbe1",
    "#fff5cb",
    "#ffea9a",
    "#ffde64",
    "#ffd438",
    "#ffce1c",
    "#ffc900",
    "#e3b300",
    "#ca9f00",
    "#af8800"
]

const aquaDark: MantineColorsTuple = [
    "#ecfdfb",
    "#dafaf5",
    "#aff5eb",
    "#83f1e0",
    "#63eed7",
    "#52ecd2",
    "#48ebcf",
    "#3bd0b7",
    "#2db9a2",
    "#0c9682"
]

export const theme = createTheme({
    components: {
        Modal: {
            styles: {
                content: {
                    background: 'light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-9))',
                    border: '1px solid var(--mantine-color-default-border)',
                },
                header: {
                    background: 'light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-9))',
                },
            },
            defaultProps: {
                radius: 'lg',
            }
        },
        Card: {
            defaultProps: {
                radius: 'md'
            }
        },
        HoverCard: {
            defaultProps: {
                radius: 'md'
            }
        },
        TableThead: {
            defaultProps: {
                //bg: "var(--mantine-color-body)",
                //c: "dimmed",
            }
        },
        Select: {
            classNames: {
                dropdown: "select-dropdown",
                input: "select-input"
            },
            defaultProps: {
                comboboxProps: selectComboboxDefaults
            }
        },
        MultiSelect: {
            classNames: {
                dropdown: "select-dropdown",
                input: "select-input"
            },
            defaultProps: {
                comboboxProps: selectComboboxDefaults
            }
        },
        Checkbox: {
            styles: {
                description: {
                    marginTop: 0,
                }
            }
        }
    },
    colors: { brand, brandLight, brandHero, royal, aqua, berry, coral, lemon, aquaDark }, 
    primaryShade: { light: 6, dark: 5 }, 
    cursorType: 'pointer',
})
